<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/502.min.svg"
    alt="502"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIcon502',
})
</script>
